// Auto-generated from BẢNG GIÁ DỊCH VỤ VBD V1.5.xlsx / docs markdown files
export const catalogData = {
  "title": "CÁC DỊCH VỤ CUNG CẤP CHO PHÂN HỆ THI CÔNG VÀ PHÂN HỆ VẬN HÀNH",
  "headers": [
    "STT",
    "Danh mục các dịch vụ cung cấp",
    "Phân hệ vận hành",
    "Phân hệ thi công"
  ],
  "financial_policy": [
    "",
    "CHÍNH SÁCH TÀI CHÍNH",
    "Tính phí",
    "Tính phí"
  ],
  "items": [
    {
      "section": "PHÂN HỆ THI CÔNG VÀ VẬN HÀNH",
      "stt": "1",
      "name": "LisEditor TC (Desktop App).\nChức năng chính  \n- Biên tập dữ liệu Địa chính. Nhập DGN, chuyển đồi tờ bản đồ.\n- Tạo và chuẩn hóa cấu trúc lớp theo Thông tư 09, trích xuất tự động từ Thông tư 26 sang Thông tư 09.\n- Thi công Hồ sơ địa chính trên Excel để xử lý thông tin đơn, chủ, giấy, hồ sơ quét -> xuất XML đơn đăng ký để đồng bộ vào hệ thống thi công\n- Xử lý trực tiếp thông tin chỉnh lý tách, gộp, chỉnh ranh, đo đạc\n- Tạo hồ sơ kỹ thuật địa chính hàng loạt\n- Tự động tạo sơ đồ Phân mảnh, phân mảnh bản đồ, đánh lại số tờ bản đồ khi đo đạc lại,...\n- Rải điểm, nối ranh, Build topo thửa.\n- Tự động kiểm tra và tạo mã định danh thửa đất\n- Nhận dạng thông tin hồ sơ giấy chứng nhận bằng chức năng AI OCR. Tạo thửa không gian từ bảng tọa độ VN2000 trên GCN. Xuất Excel PL01_KH2959 hoặc đồng bộ kết quả lên máy chủ.\n- Kiểm lỗi các thông tin không gian và thuộc tính\n- Kiểm lỗi gói sản phẩm (GML/XML/HSQ) trước khi giao nộp\n- Xuất dữ liệu không gian ra GML.\n- Nhận và Xuất Siêu dữ liệu ra  XML.\n- Đồng bộ không gian lên Hệ thống thi công Online.\n- Tải gói tin sản phẩm (GML/XML/HSQ) theo Đợt để giao nộp.",
      "marks": [
        "",
        "X"
      ]
    },
    {
      "section": "PHÂN HỆ THI CÔNG VÀ VẬN HÀNH",
      "stt": "2",
      "name": "VBDLIS TK Desktop (Desktop App).\nChức năng chính: Biên tập và xây dựng dữ liệu Thống kê Kiểm kê (Khoanh đất, Hiện trạng sử dụng đất và Số liệu biểu). Nhập BĐKĐ, BĐHT từ DGN, Xuất gói sản phẩm theo Thông tư 25, Thông tư 08, Thông tư 23/2025. Tải và đồng bộ sản phẩm lên máy chủ.",
      "marks": [
        "",
        "X"
      ]
    },
    {
      "section": "PHÂN HỆ THI CÔNG VÀ VẬN HÀNH",
      "stt": "3",
      "name": "Quy Hoạch Desktop (Desktop App).\nChức năng chính: Biên tập và xây dựng dữ liệu Quy hoạch & KHSDĐ. Cấu trúc theo Thông tư 09, Tổng hợp biểu theo Thông tư 29/2024, Thông tư 23/2025. Xuất bản đồ QHKHSDD ra DGN. Xuất gói sản phầm giao nộp theo Thông tư 25. Tải và đồng bộ sản phẩm lên máy chủ.",
      "marks": [
        "",
        "X"
      ]
    },
    {
      "section": "PHÂN HỆ THI CÔNG VÀ VẬN HÀNH",
      "stt": "4",
      "name": "GiaDat Desktop (Desktop App).\nChức năng chính: Biên tập và xây dựng dữ liệu Giá đất. Cấu trúc theo Thông tư 09, Các công cụ tính đặc tính thửa, vùng giá trị, thửa đất chuẩn theo Nghị Định 71. Quản lý Bảng giá đất của tỉnh, Áp giá từng thửa tự động từ Bảng giá đất. . Xuất gói sản phầm giao nộp theo Thông tư 25. Tải và đồng bộ sản phẩm lên máy chủ.",
      "marks": [
        "",
        "X"
      ]
    },
    {
      "section": "PHÂN HỆ THI CÔNG VÀ VẬN HÀNH",
      "stt": "5",
      "name": "DieuTraDGD Desktop (Desktop App).\nChức năng chính: Biên tập và xây dựng dữ liệu điều tra, đánh giá đất đai; kỹ thuật bảo vệ, cải tạo, phục hồi đất. Cấu trúc theo Thông tư 09. Xuất gói sản phầm giao nộp theo Thông tư 25. Tải và đồng bộ sản phẩm lên máy chủ.",
      "marks": [
        "",
        "X"
      ]
    },
    {
      "section": "PHÂN HỆ THI CÔNG VÀ VẬN HÀNH",
      "stt": "6",
      "name": "VBDLIS Thi công Online (Web App cho 05 phân hệ : Địa chính, TKKK, QHKHSDD, Giá đất, Điều tra và Đánh giá đất).\nChức năng chính: Hệ thống web trung tâm. Upload GML/XSD, nhập thuộc tính trực tuyến, tạo đợt/gói, quản lý duyệt.",
      "marks": [
        "",
        "X"
      ]
    },
    {
      "section": "PHÂN HỆ THI CÔNG VÀ VẬN HÀNH",
      "stt": "7",
      "name": "Mobile App AI OCR (Mobile App)\nChức năng chính: Ứng dụng di động hỗ trợ thi công thực địa. AI OCR nhận dạng hồ sơ giấy chứng nhận và căn cước công dân, scan giấy tờ tạo bản quét, định vị thửa đất trên bản đồ, đồng bộ lên VBDLIS.",
      "marks": [
        "",
        "X"
      ]
    },
    {
      "section": "PHÂN HỆ THI CÔNG VÀ VẬN HÀNH",
      "stt": "8",
      "name": "VBDLIS ConvertData (Desktop Tool)\nChức năng chính: Chuyển đổi & chuẩn hóa từ VILIS 2.0, CV225, XML. Ánh xạ danh mục, đồng bộ HSQ, xuất & ký số SĐC.",
      "marks": [
        "",
        "X"
      ]
    },
    {
      "section": "PHÂN HỆ THI CÔNG VÀ VẬN HÀNH",
      "stt": "9",
      "name": "VBDLIS Vận hành (hệ thống vận hành cơ sở dữ liệu đất đai chính thức cho 05 phân hệ Địa chính, TKKK, QHKHSDD, Giá đất và Điều tra đánh giá đất).\nChức năng chính: vận hành CSDL đất đai chính thức. \n- Tiếp nhận dữ liệu đã duyệt từ VBDLIS Thi công tích hợp vào CSDL pháp lý\n- Hỗ trợ đưa ecxel thu thập thông tin giấy chứng nhận",
      "marks": [
        "X",
        ""
      ]
    },
    {
      "section": "PHÂN HỆ THI CÔNG VÀ VẬN HÀNH",
      "stt": "10",
      "name": "LISEditor VPĐK (Desktop App).\nChức năng chính: \n- Biên tập dữ liệu địa chính. Nhập DGN, kiểm lỗi không gian & thuộc tính\n- Nhận, kiểm tra gói bàn giao (GML, XML, HSQ, SĐC) trước khi tích hợp CSDL vận hành.\n- Nhận dạng thông tin hồ sơ giấy chứng nhận và CCCD bằng chức năng AI OCR.\n- Tích hợp dữ liệu của 05 phân hệ : Địa chính, TKKK, Giá Đất, QHKHSDD và Điều tra đánh giá đất vào Hệ thống vận hành.\n- Tải dữ liệu của 05 phân hệ : Địa chính, TKKK, Giá Đất, QHKHSDD và Điều tra đánh giá đất vào Hệ thống vận hành.\n- Tải và tích hợp dữ liệu VNLIS",
      "marks": [
        "X",
        ""
      ]
    },
    {
      "section": "PHÂN HỆ THI CÔNG VÀ VẬN HÀNH",
      "stt": "11",
      "name": "VBDLIS DESKTOP (Desktop App).\nChức năng chính: Phiên bản Chỉnh lý biến động không gian, tạo sơ đồ thửa và Hồ sơ kỹ thuật địa chính để vận hành hàng ngày.",
      "marks": [
        "X",
        ""
      ]
    },
    {
      "section": "PHÂN HỆ THI CÔNG VÀ VẬN HÀNH",
      "stt": "12",
      "name": "VBDLIS DIGITAL (Desktop App).\nChức năng chính: Phiên bản Ký số và xuất Sổ địa chính điện tử hàng loạt để nghiệm thu.",
      "marks": [
        "X",
        "X"
      ]
    },
    {
      "section": "PHÂN HỆ THI CÔNG VÀ VẬN HÀNH",
      "stt": "B",
      "name": "Dịch vụ cung cấp hạ tầng phần cứng (thiết bị máy chủ, lưu trữ, an ninh bảo mật hệ thống, máy chủ GPU chuyên dụng xử lý đồ họa …).\nDịch vụ quản trị, vận hành hệ thống\nBao gồm:\nQuản trị máy chủ;\nAn ninh, bảo mật cơ sở dữ liệu;\nQuản trị ứng dụng/phần mềm;\nTheo dõi nhật ký hệ thống (log);\nGiám sát tình trạng hoạt động 24/7;\nXử lý sự cố kỹ thuật.\nBảo trì phần mềm;\nBảo dưỡng hạ tầng kỹ thuật;\nVá lỗi phần mềm;\nCập nhật phiên bản;\nThay thế cấu hình;\nTối ưu hệ thống.",
      "marks": [
        "X",
        ""
      ]
    },
    {
      "section": "PHÂN HỆ THI CÔNG VÀ VẬN HÀNH",
      "stt": "C",
      "name": "Dịch vụ hỗ trợ trong quá trình vận hành, bao gồm:\nĐào tạo, hướng dẫn quy trình nghiệp vụ khi triển khai phần mềm;\nBiên soạn tài liệu hướng dẫn sử dụng;\nCung cấp video.\nGiải đáp thắc mắc trong quá trình sử dụng; Hướng dẫn xử lý lỗi; Tiếp nhận yêu cầu hỗ trợ qua: điện thoại; email; Zalo/Teams.",
      "marks": [
        "",
        "X"
      ]
    },
    {
      "section": "PHÂN HỆ THI CÔNG VÀ VẬN HÀNH",
      "stt": "D",
      "name": "Dịch vụ hỗ trợ trong quá trình thi công bao gồm:\nĐào tạo, hướng dẫn quy trình thi công khi triển khai phân hệ thi công;\nBiên soạn tài liệu hướng dẫn sử dụng;\nCung cấp video.\nGiải đáp thắc mắc trong quá trình sử dụng; Hướng dẫn xử lý lỗi; Tiếp nhận yêu cầu hỗ trợ qua: điện thoại; email; Zalo/Teams.\nHướng dẫn nhập dữ liệu;\nHướng dẫn kiểm tra dữ liệu lỗi;\nHướng dẫn chuẩn hóa dữ liệu;\nHướng dẫn import/export dữ liệu.",
      "marks": [
        "X",
        "X"
      ]
    }
  ]
};

export const operationalPricingData = {
  "title": "BÁO GIÁ CUNG CẤP DỊCH VỤ THUÊ PHÂN HỆ VẬN HÀNH VBDLIS \n(Có hiệu lực đến 31/12/2026 và giá trị báo giá không thay đổi trong 03 năm)",
  "policy": "Chính sách ký hợp đồng: Có 02 phương án\n1. Ký hợp đồng cho toàn tỉnh/thành phố\n2. Ký hợp đồng với từng đơn vị hành chính xã/phường",
  "unit": "Đơn vị tính: Triệu đồng",
  "provinces": [
    {
      "stt": "1",
      "name": "Vĩnh Long",
      "prov_qty": "1",
      "prov_year": 14891,
      "prov_month": 1241,
      "total_communes": 124,
      "commune_qty": "1",
      "commune_year": 120,
      "commune_month": 10,
      "vpdk_price": 450
    },
    {
      "stt": "2",
      "name": "Thái Nguyên",
      "prov_qty": "1",
      "prov_year": 13926,
      "prov_month": 1160,
      "total_communes": 92,
      "commune_qty": "1",
      "commune_year": 151,
      "commune_month": 13,
      "vpdk_price": 450
    },
    {
      "stt": "3",
      "name": "Bắc Ninh",
      "prov_qty": "1",
      "prov_year": 14713,
      "prov_month": 1226,
      "total_communes": 99,
      "commune_qty": "1",
      "commune_year": 149,
      "commune_month": 12,
      "vpdk_price": 450
    },
    {
      "stt": "4",
      "name": "Ninh Bình",
      "prov_qty": "1",
      "prov_year": 11716,
      "prov_month": 976,
      "total_communes": 129,
      "commune_qty": "1",
      "commune_year": 91,
      "commune_month": 8,
      "vpdk_price": 450
    },
    {
      "stt": "5",
      "name": "Quảng Ngãi",
      "prov_qty": "1",
      "prov_year": 10700,
      "prov_month": 892,
      "total_communes": 96,
      "commune_qty": "1",
      "commune_year": 111,
      "commune_month": 9,
      "vpdk_price": 450
    },
    {
      "stt": "6",
      "name": "Đak Lak",
      "prov_qty": "1",
      "prov_year": 14699,
      "prov_month": 1225,
      "total_communes": 102,
      "commune_qty": "1",
      "commune_year": 144,
      "commune_month": 12,
      "vpdk_price": 450
    },
    {
      "stt": "7",
      "name": "Tỉnh Tuyên Quang",
      "prov_qty": "1",
      "prov_year": 6701,
      "prov_month": 558,
      "total_communes": 124,
      "commune_qty": "1",
      "commune_year": 54,
      "commune_month": 5,
      "vpdk_price": 450
    },
    {
      "stt": "8",
      "name": "Tỉnh Điện Biên",
      "prov_qty": "1",
      "prov_year": 1419,
      "prov_month": 118,
      "total_communes": 45,
      "commune_qty": "1",
      "commune_year": 32,
      "commune_month": 3,
      "vpdk_price": 450
    },
    {
      "stt": "9",
      "name": "Tỉnh Sơn La",
      "prov_qty": "1",
      "prov_year": 5911,
      "prov_month": 493,
      "total_communes": 75,
      "commune_qty": "1",
      "commune_year": 79,
      "commune_month": 7,
      "vpdk_price": 450
    },
    {
      "stt": "10",
      "name": "Tỉnh Lào Cai",
      "prov_qty": "Sẽ báo giá cụ thể tại thời điểm yêu cầu",
      "prov_year": "",
      "prov_month": "",
      "total_communes": "",
      "commune_qty": "",
      "commune_year": "",
      "commune_month": "",
      "vpdk_price": ""
    },
    {
      "stt": "11",
      "name": "Thành phố Hải Phòng",
      "prov_qty": "1",
      "prov_year": 15530,
      "prov_month": 1294,
      "total_communes": 114,
      "commune_qty": "1",
      "commune_year": 136,
      "commune_month": 11,
      "vpdk_price": 450
    },
    {
      "stt": "12",
      "name": "Tỉnh Hưng Yên",
      "prov_qty": "1",
      "prov_year": 12594,
      "prov_month": 1049,
      "total_communes": 104,
      "commune_qty": "1",
      "commune_year": 121,
      "commune_month": 10,
      "vpdk_price": 450
    },
    {
      "stt": "13",
      "name": "Tỉnh Nghệ An",
      "prov_qty": "1",
      "prov_year": 17710,
      "prov_month": 1476,
      "total_communes": 130,
      "commune_qty": "1",
      "commune_year": 136,
      "commune_month": 11,
      "vpdk_price": 450
    },
    {
      "stt": "14",
      "name": "Tỉnh Hà Tĩnh",
      "prov_qty": "1",
      "prov_year": 9400,
      "prov_month": 783,
      "total_communes": 69,
      "commune_qty": "1",
      "commune_year": 136,
      "commune_month": 11,
      "vpdk_price": 450
    },
    {
      "stt": "15",
      "name": "Tỉnh Quảng Trị",
      "prov_qty": "1",
      "prov_year": 8586,
      "prov_month": 716,
      "total_communes": 78,
      "commune_qty": "1",
      "commune_year": 110,
      "commune_month": 9,
      "vpdk_price": 450
    },
    {
      "stt": "16",
      "name": "Thành phố Huế",
      "prov_qty": "1",
      "prov_year": 2402,
      "prov_month": 200,
      "total_communes": 40,
      "commune_qty": "1",
      "commune_year": 60,
      "commune_month": 5,
      "vpdk_price": 450
    },
    {
      "stt": "17",
      "name": "Thành phố Đà Nẵng",
      "prov_qty": "Sẽ báo giá cụ thể tại thời điểm yêu cầu",
      "prov_year": "",
      "prov_month": "",
      "total_communes": "",
      "commune_qty": "",
      "commune_year": "",
      "commune_month": "",
      "vpdk_price": ""
    },
    {
      "stt": "18",
      "name": "Tỉnh Gia Lai",
      "prov_qty": "1",
      "prov_year": 16719,
      "prov_month": 1393,
      "total_communes": 135,
      "commune_qty": "1",
      "commune_year": 124,
      "commune_month": 10,
      "vpdk_price": 450
    },
    {
      "stt": "19",
      "name": "Tỉnh Khánh Hòa",
      "prov_qty": "1",
      "prov_year": 8855,
      "prov_month": 738,
      "total_communes": 65,
      "commune_qty": "1",
      "commune_year": 136,
      "commune_month": 11,
      "vpdk_price": 450
    },
    {
      "stt": "20",
      "name": "Tỉnh Lâm Đồng",
      "prov_qty": "1",
      "prov_year": 13961,
      "prov_month": 1163,
      "total_communes": 124,
      "commune_qty": "1",
      "commune_year": 113,
      "commune_month": 9,
      "vpdk_price": 450
    },
    {
      "stt": "21",
      "name": "Thành phố Hồ Chí Minh",
      "prov_qty": "1",
      "prov_year": 36315,
      "prov_month": 3026,
      "total_communes": 168,
      "commune_qty": "1",
      "commune_year": 216,
      "commune_month": 18,
      "vpdk_price": 450
    },
    {
      "stt": "22",
      "name": "Tỉnh Tây Ninh",
      "prov_qty": "1",
      "prov_year": 14531,
      "prov_month": 1211,
      "total_communes": 96,
      "commune_qty": "1",
      "commune_year": 151,
      "commune_month": 13,
      "vpdk_price": 450
    },
    {
      "stt": "23",
      "name": "Thành phố Cần Thơ",
      "prov_qty": "1",
      "prov_year": 15591,
      "prov_month": 1299,
      "total_communes": 103,
      "commune_qty": "1",
      "commune_year": 151,
      "commune_month": 13,
      "vpdk_price": 450
    },
    {
      "stt": "24",
      "name": "Đồng Tháp",
      "prov_qty": "1",
      "prov_year": 12632,
      "prov_month": 1053,
      "total_communes": 102,
      "commune_qty": "1",
      "commune_year": 124,
      "commune_month": 10,
      "vpdk_price": 450
    }
  ],
  "notes": [
    "1. Trường hợp tính theo tháng thì trên cơ sở báo giá thuê tính theo năm được chia cho 12 tháng",
    "2. Cơ sở lập báo giá: Công ty Cổ phần Tin học - Bản đồ Việt Nam đã có Công văn gửi từng tỉnh vào ngày 16/3/2026"
  ]
};

export const constructionPricingData = {
  "title": "BÁO GIÁ CUNG CẤP DỊCH VỤ THUÊ PHÂN HỆ THI CÔNG",
  "headers": [
    "STT",
    "Nội dung",
    "Ký hiệu/ghi chú",
    "Chính sách ưu đãi"
  ],
  "items": [
    {
      "stt": "1",
      "content": "Giá trị hợp đồng đã ký giữa Chủ đầu tư và Nhà thầu thi công (đã bao gồm thuế VAT)",
      "symbol": "G \n(G=G1+G2)",
      "promo": ""
    },
    {
      "stt": "1.1",
      "content": "Giá trị hợp đồng đã ký giữa Chủ đầu tư và Nhà thầu thi công (đã bao gồm thuế VAT) của hạng mục Đo đạc, lập bản đồ địa chính.",
      "symbol": "G1",
      "promo": ""
    },
    {
      "stt": "1.2",
      "content": "Giá trị hợp đồng đã ký giữa Chủ đầu tư và Nhà thầu thi công (đã bao gồm thuế VAT) của hạng mục Kê khai đăng ký, cấp GCN và Xây dựng cơ sở dữ liệu",
      "symbol": "G2",
      "promo": ""
    },
    {
      "stt": "2",
      "content": "Giá trị ký hợp đồng Dịch vụ Thuê Phân hệ thi công (được thông qua hợp đồng giữa Nhà thầu thi công và Công ty VIETBANDO)",
      "symbol": "5% * G\nĐối với trường hợp Nhà thầu thi công có nhu cầu sử dụng các công cụ  đầy đủ các bước (đo đạc, hoàn thiện bản đồ địa chính, kê khai đăng ký và xây dựng cơ sở dữ liệu)",
      // "promo": "Ưu đãi đối với các nhà thầu thi công khi ký hợp đồng với Công ty VIETBANDO ở thời điểm ký hợp đồng trước ngày 30/6/2026: 3%*G"
      "promo": ""
    },
    {
      "stt": "3",
      "content": "Giá trị ký hợp đồng Dịch vụ Thuê Phân hệ thi công (được thông qua hợp đồng giữa Nhà thầu thi công và Công ty VIETBANDO)",
      "symbol": "5% * G2\nĐối với trường hợp Nhà thầu thi công chỉ có nhu cầu sử dụng các công cụ  kê khai đăng ký và xây dựng cơ sở dữ liệu (Nhà thầu thi công đo đạc, hoàn thiện bản đồ địa chính bằng các công cụ khác)",
      // "promo": "Ưu đãi đối với các nhà thầu thi công khi ký hợp đồng với Công ty VIETBANDO ở thời điểm ký hợp đồng trước ngày 30/6/2026: 3%*G2"
      "promo": ""
    },
    {
      "stt": "4",
      "content": "Phạm vi, quy mô cung cấp dịch vụ phân hệ thi công",
      "symbol": "Đúng theo phạm vi, quy mô trong hợp đồng đã ký giữa Chủ đầu tư và Nhà thầu thi công",
      "promo": ""
    },
    {
      "stt": "5",
      "content": "Phương thức và giá trị thanh toán:",
      "symbol": "",
      "promo": ""
    },
    {
      "stt": "5.1",
      "content": "Tạm ứng phí dịch vụ thuê Phân hệ thi công",
      // "symbol": "100.000.000 VNĐ",
      "symbol": "5% GIÁ TRỊ NHÀ THẦU ĐƯỢC TẠM ỨNG",
      "promo": "Trong vòng 15 ngày sau khi hợp đồng có hiệu lực"
    },
    {
      "stt": "5.2",
      "content": "Giá trị thanh toán phí dịch vụ thuê Phân hệ thi công (theo giá trị thực tế được thanh toán giữa Nhà thầu Thi công và Chủ đầu tư)",
      "symbol": "(5% * giá trị nhà thầu được thanh toán) - (giá trị tạm ứng)",
      // "promo": "Ưu đãi đối với các nhà thầu thi công khi ký hợp đồng với Công ty VIETBANDO ở thời điểm ký hợp đồng trước ngày 30/6/2026: (3% * giá trị nhà thầu được thanh toán) - (giá trị tạm ứng)"
      "promo": ""
    },
    {
      "stt": "5.3",
      "content": "Số lần thanh toán: Theo số lần Nhà thầu thi công được thanh toán từ Chủ đầu tư",
      "symbol": "Trong vòng 20 ngày kể từ khi Nhà thầu nhận được thanh toán kinh phí từ Chủ đầu tư. Nhà thầu thi công có trách nhiệm thanh toán cho Công ty VIETBANDO.",
      "promo": ""
    },
    {
      "stt": "6",
      "content": "Thời gian cung cấp dịch vụ Thuê phân hệ thi công",
      "symbol": "Theo thời gian thực hiện hợp đồng giữa Chủ đầu tư và Nhà thầu thi công",
      "promo": ""
    }
  ],
  "notes": [
    "1. Các điều kiện về trách nhiệm giữa các bên tham gia ký hợp đồng được cụ thể tại các Điều, Khoản trong Hợp đồng;",
    "2. Mọi  vấn đề về thương thảo hợp đồng, giải quyết các vướng mắc trong nội dung hợp đồng, liên hệ: Ông Nguyễn Trường Sơn - Giám đốc triển khai - Số ĐT: 0362697998"
  ]
};
